import React from "react"
import { withRouter } from "react-router"
import withAuth from "../../components/auth"


function EventSelectors() {

  return (
    <div className="content-body">
      <div className="container-fluid">
        <list-selectors />
      </div>
    </div>
  );
}

export default withRouter(withAuth(EventSelectors))